import type { MenuConfig } from '~typings/menu'

import permisosCompras, { RESOURCE_COMPRAS } from '@/auth/permissions/modules/compras'
import * as names from '@routes/compras/nombres/transacciones'

const { transacciones } = permisosCompras

export default [
    {
        title: 'compras.subopciones.solicitudes_compra',
        resource: RESOURCE_COMPRAS,
        action: transacciones.solicitudesCompra._perm,
        children: [
            {
                title: 'compras.subopciones.gestion_solicitud',
                route: names.ROUTE_GESTION_SOLICITUDES,
                resource: RESOURCE_COMPRAS,
                action: transacciones.solicitudesCompra.gestionSolicitudes,
            },
            {
                title: 'compras.subopciones.generar_solicitud',
                route: names.ROUTE_CREACION_SOLICITUD,
                resource: RESOURCE_COMPRAS,
                action: transacciones.solicitudesCompra.creacionSolicitud,
            },
            {
                title: 'compras.subopciones.preaprobacion_solicitudes',
                route: names.ROUTE_APROBACION_CATEGORIA_SOLICITUDES,
                resource: RESOURCE_COMPRAS,
                action: transacciones.solicitudesCompra.aprobacionSolicitudCategoria,
            },
            {
                title: 'compras.subopciones.aprobacion_solicitudes',
                route: names.ROUTE_APROBACION_SOLICITUDES,
                resource: RESOURCE_COMPRAS,
                action: transacciones.solicitudesCompra.aprobacionSolicitud,
            },
            {
                title: 'compras.subopciones.gestion_publicaciones',
                route: names.ROUTE_GESTION_PUBLICACIONES_SOLICITUD,
                resource: RESOURCE_COMPRAS,
                action: transacciones.solicitudesCompra.gestionPublicacionesSolicitud,
            },
        ],
    },
    {
        title: 'compras.subopciones.cotizaciones',
        resource: RESOURCE_COMPRAS,
        action: transacciones.cotizaciones._perm,
        children: [
            {
                title: 'compras.subopciones.gestion_cotizaciones',
                route: names.ROUTE_GESTION_COTIZACIONES,
                resource: RESOURCE_COMPRAS,
                action: transacciones.cotizaciones.gestionCotizaciones,
            },
            {
                title: 'compras.subopciones.generar_cotizacion',
                route: names.ROUTE_CREACION_COTIZACION,
                resource: RESOURCE_COMPRAS,
                action: transacciones.cotizaciones.creacionCotizacion,
            },
        ],
    },
    {
        title: 'compras.subopciones.ordenes_compra',
        resource: RESOURCE_COMPRAS,
        action: transacciones.ordenesCompra._perm,
        children: [
            {
                title: 'compras.subopciones.gestion_orden_compra',
                route: names.ROUTE_GESTION_ORDENES_COMPRA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesCompra.gestionOrdenCompra,
            },
            {
                title: 'compras.subopciones.generar_orden_compra',
                route: names.ROUTE_CREACION_ORDEN_COMPRA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesCompra.creacionOrdenCompra,
            },
            {
                title: 'compras.subopciones.aprobacion_orden_compra',
                route: names.ROUTE_APROBACION_ORDEN_COMPRA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesCompra.aprobacionOC,
            },
        ],
    },
    {
        title: 'compras.subopciones.ordenes_entrega',
        resource: RESOURCE_COMPRAS,
        action: transacciones.ordenesEntrega._perm,
        children: [
            {
                title: 'compras.subopciones.gestion_orden_entrega',
                route: names.ROUTE_GESTION_ORDENES_ENTREGA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesEntrega.gestionOrdenEntrega,
            },
            {
                title: 'compras.subopciones.generar_orden_entrega',
                route: names.ROUTE_CREACION_ORDEN_ENTREGA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesEntrega.creacionOrdenEntrega,
            },
            {
                title: 'compras.subopciones.recepcion_orden_entrega_bien',
                route: names.ROUTE_RECEPCION_ORDEN_ENTREGA_BIEN,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesEntrega.recepcionOrdenEntregaBien,
            },
            {
                title: 'compras.subopciones.recepcion_orden_entrega_servicio',
                route: names.ROUTE_RECEPCION_ORDEN_ENTREGA_SERVICIO,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesEntrega.recepcionOrdenEntregaServicio,
            },
            {
                title: 'compras.subopciones.revision_recepcion_orden_entrega',
                route: names.ROUTE_REVISION_RECEPCION_ORDEN_ENTREGA,
                resource: RESOURCE_COMPRAS,
                action: transacciones.ordenesEntrega.revisionRecepcionOrdenEntrega,
            },
        ],
    },
] as MenuConfig[]
